type TextCellProps = {
  value: string | undefined;
};

export const TextCell = ({ value }: TextCellProps) => {
  return <span className="text-gray-700">{value}</span>;
};
